import Vue                              from "vue";
import { mapGetters }                   from "vuex";
import { formatDateTime, stringHelper } from "@/components/mixins";
import moment                           from "moment";
import { WysiwygHtmlArea }  from "@/components/Elements/WysiwygHtmlArea"

export default Vue.extend({
    name: "NewsSummary",
    components: {
        WysiwygHtmlArea
    },
    mixins: [formatDateTime, stringHelper],
    props: {
        newsStory: {},
        isHomePage: Boolean
      },
    created() {
    },
    computed: {
        ...mapGetters([
            "user",
            "getContentItem",
        ]),
    },
    data: () => ({
    }),
    methods: {
        formatNewsStoryDate: function(value: string | Date) {
            return moment(value).format("MMM D, YYYY");
        },
        loadNewsStory(storyId : number) {
            this.$emit("load-story", storyId);
        }
    },
    watch: {
    },
});
